<template>
  <div class="text-sm">
    <p>We've a wrong turn somewhere here.</p>
    <p>This isn't a valid view.</p>
    <p>
      <a class="underline cursor-pointer" href="#" @click.prevent="close"
        >Close</a
      >
    </p>
  </div>
</template>

<script setup>
const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>
